module.exports = __webpack_public_path__ + "static/media/Clams.1ddca1a0.svg";